<template>
    <div>
      <trademark-search-success-rate-list></trademark-search-success-rate-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  